import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.css']
})
export class GenericDialogComponent implements OnInit {

  dialogTitle: string;
  dialogMessage: string;
  dialogFirstButtonText: string;
  dialogSecondButtonText: string;
  dialogFirstButtonIcon: string;
  dialogSecondButtonIcon: string;

  constructor(public dialogRef: MatDialogRef<GenericDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { 

    this.dialogTitle = data.dialogTitle;
    this.dialogMessage = data.dialogMessage;
    this.dialogFirstButtonText = data.dialogFirstButtonText;
    this.dialogSecondButtonText = data.dialogSecondButtonText;
    this.dialogFirstButtonIcon = data.dialogFirstButtonIcon;
    this.dialogSecondButtonIcon = data.dialogSecondButtonIcon;
  }

  ngOnInit() {
  }

  closeGenericDialog( ) {

    this.dialogRef.close({ confirm: false });
  }

  firstButtonClick() {

    this.dialogRef.close({ confirm: true });
  }

  secondButtonClick() {

    this.dialogRef.close({ confirm: false });
  }
}
